import { render, staticRenderFns } from "./channel_ref_edit.vue?vue&type=template&id=323693b6&scoped=true"
import script from "./channel_ref_edit.vue?vue&type=script&lang=js"
export * from "./channel_ref_edit.vue?vue&type=script&lang=js"
import style0 from "./channel_ref_edit.vue?vue&type=style&index=0&id=323693b6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323693b6",
  null
  
)

export default component.exports